import { AlertTriangle, X } from "lucide-react";

export const ConfirmModal = ({
  open,
  title,
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  danger = false,
  onConfirm,
  onCancel,
  busy = false,
  testid = "confirm-modal",
}) => {
  if (!open) return null;
  return (
    <div className="mvp-modal-backdrop" onClick={busy ? undefined : onCancel} data-testid={`${testid}-backdrop`}>
      <div className="mvp-modal" onClick={(e) => e.stopPropagation()} data-testid={testid}>
        <button className="mvp-modal-close" onClick={onCancel} disabled={busy} aria-label="Close" data-testid={`${testid}-close`}>
          <X size={16} />
        </button>
        <div className="mvp-modal-icon">
          <AlertTriangle size={22} />
        </div>
        <h3>{title}</h3>
        <p>{message}</p>
        <div className="mvp-modal-actions">
          <button
            className="mvp-nav-ghost"
            onClick={onCancel}
            disabled={busy}
            data-testid={`${testid}-cancel-btn`}
          >
            {cancelLabel}
          </button>
          <button
            className={`btn-primary mvp-cta-sm ${danger ? "mvp-danger" : ""}`}
            onClick={onConfirm}
            disabled={busy}
            data-testid={`${testid}-confirm-btn`}
          >
            {busy ? "Working…" : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};
